module.exports = __webpack_public_path__ + "static/media/ico-arrow-left-nav.287ba04e.svg";